<script setup>
import ProjectCard from '@/Components/ProjectCard.vue'

defineProps({
    showHeader: {
        type: Boolean,
        default: true,
    },

    overflowScroll: {
        type: Boolean,
        default: false,
    },

    projects: {
        type: Array,
        default: () => [],
        required: false,
    },
})
</script>

<template>
    <section
        id="stavby"
        aria-label="Programátorské akce zaměřené na Laravel, Inertia.js, Vue.js a Tailwind CSS"
        class="scroll-mt-32"
    >
        <header
            v-if="showHeader"
            class="header-width"
        >
            <h2 class="header-h">Stavby</h2>
            <p class="header-p">
                Nabízíme široký sortiment služeb zaměřených na montáže sádrokartonů, foukané izolace a betonové stěrky.
                Naše služby zahrnují jak drobné opravy, tak i velké projekty.
            </p>
        </header>

        <div
            :class="[
                showHeader ? 'mt-4 lg:mt-10' : 'mt-0',
                'grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-5 lg:grid-cols-3 lg:gap-5',
            ]"
        >
            <ProjectCard
                v-for="project in projects"
                :key="project.id"
                :project="project"
            />
        </div>
    </section>
</template>
